/**
 * Converte VAPID public key (base64url) pra Uint8Array exigido por
 * `PushManager.subscribe({ applicationServerKey })`.
 *
 * web-push emite chaves em base64url sem padding. Browser pushManager exige
 * Uint8Array com bytes cruos. Essa função faz:
 *   1. padding pra múltiplo de 4
 *   2. substituição URL-safe chars (-_) pra base64 (+/)
 *   3. atob → string binária → Uint8Array
 *
 * Portado do hook-old (src/hooks/usePushNotifications.ts).
 */
export function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(b64);
  const arr = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    arr[i] = rawData.charCodeAt(i);
  }
  return arr;
}
